export default __webpack_public_path__ + "static/media/Neophyte's Armbands of Sovereign Rule.b92bf303.jpg";